var _dec, _class, _TopNavBarUser;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component, Children } from 'react';
import { error } from '@instructure/console';
import { omitProps } from '@instructure/ui-react-utils';
import { withStyle } from '@instructure/emotion';
import { TopNavBarContext } from "../TopNavBarContext.js";
import generateStyle from "./styles.js";
import { allowedProps } from "./props.js";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
parent: TopNavBar
id: TopNavBar.User
---
@module TopNavBarUser
**/
let TopNavBarUser = (_dec = withStyle(generateStyle, null), _dec(_class = (_TopNavBarUser = class TopNavBarUser extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  get content() {
    const children = Children.toArray(this.props.children);
    const allowedVariants = ['default', 'button', 'avatar'];
    return Children.map(children, child => {
      const _child$props = child.props,
        id = _child$props.id,
        variant = _child$props.variant;
      if (variant && !allowedVariants.includes(variant)) {
        error(false, `Item with id "${id}" has "${variant}" variant, but only the following variants are allowed in <TopNavBarUser>: ${allowedVariants.join(', ')}.`);
        return null;
      }
      return child;
    });
  }
  render() {
    const styles = this.props.styles;
    if (!this.content || this.content.length === 0) {
      return null;
    }
    if (this.context.layout === 'smallViewport') {
      // in smallViewport mode it is rendered as a Drilldown
      return null;
    }
    return _jsx("div", {
      ...omitProps(this.props, allowedProps),
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.topNavBarUser,
      "data-cid": "TopNavBarUser",
      children: this.content
    });
  }
}, _TopNavBarUser.displayName = "TopNavBarUser", _TopNavBarUser.componentId = 'TopNavBar.User', _TopNavBarUser.allowedProps = allowedProps, _TopNavBarUser.defaultProps = {}, _TopNavBarUser.contextType = TopNavBarContext, _TopNavBarUser)) || _class);
export { TopNavBarUser };
export default TopNavBarUser;